import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {StatoEnum} from "./enums/stato.enum";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}
  async canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const currentUser = this.authService.getUser();
    if (currentUser) {
      if (currentUser.membro.account.stato === StatoEnum.PrimoAccesso || currentUser.membro.account.stato === StatoEnum.CambioPassword) {
        this.router.navigate(['/user/change-password']);
      }
      if (route.data && route.data.roles) {
        if (route.data.roles.includes(currentUser.membro.account.ruolo)) {
          return true;
        } else {
          this.router.navigate(['/unauthorized']);
          return false;
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/user/login']);
      return false;
    }
  }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.getUser();
    if (currentUser) {
      if (route.data && route.data.roles) {
        if (route.data.roles.includes(currentUser.membro.account.ruolo)) {
          return true;
        } else {
          this.router.navigate(['/unauthorized']);
          return false;
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/user/login']);
      return false;
    }
  }
}
